/**
 * Une source (`feed`), en mouvement réduit : « il parle » se décide une fois pour les trois barres, sur la plus haute,
 * au-dessus du bruit d'un micro ouvert (un bruit moyen de 0,005 donne déjà 0,14), et tient 700 ms après le dernier
 * mot, sinon les barres sauteraient à chaque syllabe.
 */
const FEED_SPEAKING = 0.3
const FEED_SPEAKING_HOLD_MS = 700

/** Mouvement réduit, une source : parle-t-il, sur la plus haute des barres, maintenu 700 ms après le dernier mot ? */
export function calmVoiceStep(
    levels: readonly number[],
    now: number,
    spokeAt: number
): { speaking: boolean; spokeAt: number } {
    const last = Math.max(0, ...levels) > FEED_SPEAKING ? now : spokeAt
    return { speaking: now - last < FEED_SPEAKING_HOLD_MS, spokeAt: last }
}
